function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AuthPluginAnonymous, AuthPluginParent, AuthPluginPsk } from '@deephaven/auth-plugins';
import { LoadingOverlay } from '@deephaven/components';
import { useClient } from '@deephaven/jsapi-bootstrap';
import { getErrorMessage } from '@deephaven/utils';
import { PluginsContext } from '@deephaven/plugin';
import { getAuthPluginComponent } from "../plugins/index.js";
import LoginNotifier from "./LoginNotifier.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/** Core auth plugins that are always loaded */
var CORE_AUTH_PLUGINS = new Map([['@deephaven/auth-plugins.AuthPluginParent', {
  AuthPlugin: AuthPluginParent
}], ['@deephaven/auth-plugins.AuthPluginPsk', {
  AuthPlugin: AuthPluginPsk
}], ['@deephaven/auth-plugins.AuthPluginAnonymous', {
  AuthPlugin: AuthPluginAnonymous
}]]);

/**
 * AuthBootstrap component. Handles displaying the auth plugin and authenticating.
 */
export function AuthBootstrap(_ref) {
  var children = _ref.children;
  var client = useClient();
  // `useContext` instead of `usePlugins` so that we don't have to wait for the plugins to load
  // We want to load the auth config values in parallel with the plugins
  var plugins = useContext(PluginsContext);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    authConfig = _useState2[0],
    setAuthConfig = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  useEffect(function initAuthConfigValues() {
    var isCanceled = false;
    function loadAuthConfigValues() {
      return _loadAuthConfigValues.apply(this, arguments);
    }
    function _loadAuthConfigValues() {
      _loadAuthConfigValues = _asyncToGenerator(function* () {
        try {
          var newAuthConfigValues = yield client.getAuthConfigValues();
          if (!isCanceled) {
            setAuthConfig(new Map(newAuthConfigValues));
          }
        } catch (e) {
          if (!isCanceled) {
            setError(e);
          }
        }
      });
      return _loadAuthConfigValues.apply(this, arguments);
    }
    loadAuthConfigValues();
    return () => {
      isCanceled = true;
    };
  }, [client]);
  var AuthComponent = useMemo(() => {
    if (plugins == null || authConfig == null) {
      return undefined;
    }
    try {
      return getAuthPluginComponent(plugins, authConfig, CORE_AUTH_PLUGINS);
    } catch (e) {
      setError(e);
    }
  }, [authConfig, plugins]);
  var isLoading = AuthComponent == null || authConfig == null;
  if (isLoading || error != null) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      isLoading: isLoading && error == null,
      errorMessage: getErrorMessage(error),
      "data-testid": "auth-bootstrap-loading-error"
    });
  }
  return /*#__PURE__*/_jsx(AuthComponent, {
    authConfigValues: authConfig,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LoginNotifier, {}), children]
    })
  });
}
export default AuthBootstrap;
//# sourceMappingURL=AuthBootstrap.js.map